import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { HouseholdAssociations } from 'app/models/household/household-associations';
import { IWellViewModel } from 'app/models/well/well.viewmodel';
import { HouseholdService } from 'app/services/household-service';
import { ToastrService } from 'ngx-toastr';
import { HouseholdAssociation } from 'app/models/household/household-association';
import { DialogEditHouseholdComponent } from '../edit/household-edit-dialog';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';
import { DialogEditHousingUnitComponent } from '../edit/units/housingunit-edit-dialog';
import { DialogAssociateHousingUnitToHouseholdComponent } from './associate/associate-housingunit-household-dialog';
import { DialogEditHousingUnitAssociationComponent } from '../edit/units/housingunit-association-edit-dialog';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'household-associations',
  templateUrl: './household-associations.component.html',
  styleUrls: ['./household-associations.component.scss']
})
export class HouseholdAssociationsComponent implements OnInit {
  processing = false;

  // Households
  @Input('householdId')
  householdId: number = 0;
  associations: HouseholdAssociations = null;
  households: IHousehold[] = [];
  displayedColumnsHouseholds: string[] = ['id', 'contactName', 'address1', 'city', 'zip', 'county', 'waterTreamentProvided', 'bottledWaterProvided', 'personsInHousehold'];
  dataSourceHouseholds = new MatTableDataSource<IHousehold>();

  filterTableHouseholds(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceHouseholds.filter = value.trim().toLowerCase();
  }

  // Housing Unit Associations
  @Input('housingUnits')
  housingUnits: boolean = false;
  displayedColumnsHousingUnits: string[] = ['id', 'contactName', 'address1', 'city', 'zip', 'county', 'startDate', 'endDate', 'actions'];
  dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>();

  filterTableHousingUnits(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceHousingUnits.filter = value.trim().toLowerCase();
  }

  //Well Associations
  @Input('wellId')
  wellId: number = 0;
  displayedColumnsWells: string[] = ['id', 'wellAddress', 'county', 'wellLog', 'tag', 'actions'];
  dataSourceWells = new MatTableDataSource<IWellViewModel>();

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  @ViewChild('TablePaginatorHousehold') paginatorHousehold: MatPaginator;
  @ViewChild('TableSortHousehold') sortHousehold: MatSort;

  
  pageSize = 10;
  resultSize: number = 0;
  resultSizeHouseholds: number = 0;

  filterTableWells(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceWells.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog,
    public householdService: HouseholdService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService,) {
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    if (this.householdId > 0) {
      this.loadHouseholdAssociations();
    }
    else if(this.wellId > 0) {
      this.loadWellHouseholds();
    }
  }

  loadWellHouseholds() {
    //this.dataSourceHouseholds = new MatTableDataSource<IHousehold>([]);
    this.processing = true;
    this.householdService.getWellHouseholds(this.wellId).subscribe(
      result => {
        this.households = result;
        this.resultSizeHouseholds = this.households.length;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dataSourceHouseholds = new MatTableDataSource<IHousehold>(this.households);
        this.dataSourceHouseholds.paginator = this.paginatorHousehold;
        this.dataSourceHouseholds.sort = this.sortHousehold;
      }
    );
  }

  loadHouseholdAssociations() {
    this.processing = true;

    this.householdService.getHouseholdAssociations(this.householdId).subscribe(
      result => {
        this.associations = result;
        this.resultSize = result.housingUnits.length;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>(this.associations.housingUnits);
        this.dataSourceHousingUnits.paginator = this.paginator;
        this.dataSourceHousingUnits.sort = this.sort;
      }
    );
  }

  editHousehold(householdId: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: householdId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  editHousingUnit(housingUnitId: number) {
    const dialogRef = this.dialog.open(DialogEditHousingUnitComponent, {
      width: '90%',
      data: housingUnitId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  editAssociatedHousingUnit(housingUnitId: number, householdHousingUnitKey: number){
    const dialogRef = this.dialog.open(DialogEditHousingUnitAssociationComponent, {
      width: '90%',
      data: {housingUnitId: housingUnitId, householdHousingUnitKey: householdHousingUnitKey},
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  associateHousingUnitToHousehold() {
    if (this.householdId <= 0) {
      this.toastr.error('Invalid Household');
      return;
    }

    let association: HouseholdAssociation = {
      wellId: 0,
      voucherId: 0,
      householdId: this.householdId,
      housingUnitId: 0,
      housingUnitStartDate: '',
      housingUnitEndDate: ''
    }

    const dialogRef = this.dialog.open(DialogAssociateHousingUnitToHouseholdComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  disassociateHousingUnitFromHousehold(householdHousingUnitKey: number) {
    this.sharedService.openConfirm("Are you sure you want to dissociate this Household and Housing Unit?");

    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.householdService.disassociateHousingUnitFromHousehold(householdHousingUnitKey).subscribe(
          result => {
            this.toastr.success('Household and Housing Unit disassociated');
            this.load();
          },
          error => {
            this.toastr.error('Unable to to dissociate this Household and Housing Unit: ' + error.message);
            this.processing = false;
          }
        );
      }
    });
  }

  // #region Household

  /*
  associateWellToHousehold() {
    if (this.wellId <= 0) {
      this.toastr.error('Invalid Well');
      return;
    }

    let association: HouseholdAssociation = {
      wellId: this.wellId,
      voucherId: 0,
      householdId: 0,
      housingUnitId: 0
    }

    const dialogRef = this.dialog.open(DialogAssociateWellToHouseholdComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  editWell(wellId: number) {
    const dialogRef = this.dialog.open(DialogEditWellComponent, {
      width: '90%',
      data: wellId,
    });
    dialogRef.afterClosed().subscribe(result => {
    });    
  }
  

  associateHouseholdToWell() {
    if (this.householdId <= 0) {
      this.toastr.error('Invalid Household');
      return;
    }

    let association: HouseholdAssociation = {
      wellId: 0,
      voucherId: 0,
      householdId: this.householdId,
      housingUnitId: 0
    }

    const dialogRef = this.dialog.open(DialogAssociateWellToHouseholdComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  disassociateFromWell(householdId: number, wellId: number) {
    this.sharedService.openConfirm("Are you sure you want to dissociate this Household and Well?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.householdService.disassociateHouseholdFromWell(householdId, wellId).subscribe(
          result => {
            this.toastr.success('Household and Well disassociated');
            this.load();
          },
          error => {
            this.toastr.error('Unable to to dissociate this Bousehold and Well: ' + error.message);
            this.processing = false;
          }
        );
      }
    });
  }

  disassociateFromVoucher(householdId: number, wellId: number) {
    this.sharedService.openConfirm("Are you sure you want to dissociate this Household and Voucher?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.householdService.disassociateHouseholdFromVoucher(householdId, wellId).subscribe(
          result => {
            this.toastr.success('Household and voucher disassociated');
            this.load();
          },
          error => {
            this.toastr.error('Unable to to dissociate this Household and Voucher: ' + error.message);
            this.processing = false;
          }
        );
      }
    });
  }
  */

  // #endregion
}